import { DoneAllRounded } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { CurrencyFormat } from "../currencyformatter";

export const Reciept = ({ data }) => {
  const {
    mode,
    transaction_type,
    amount,
    accountnumber,
    fullname,
    date,
    uid,
  } = data;

  const isCredit = transaction_type === "Credit";

  return (
   
      <div
      id="content-id"
        style={{
          width: "100%",
          marginLeft: "auto",
          boxSizing: "border-box",
          marginRight: "auto",
          display: "block",

          maxWidth: "450px",
        }} //  style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        {
          //  <img src={require("../../images/logo.png")} />
        }
        <Card sx={{ backgroundColor: "#f9f9f9" }} variant="outlined">
          <CardContent>
            <Grid
              container
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid item xs={12} md={12}>
                <Stack
                  direction="column"
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Avatar
                    sx={{ width: 70, height: 70, backgroundColor: "green" }}
                  >
                    <DoneAllRounded sx={{ fontSize: 50 }} />
                  </Avatar>
                  <Typography variant="h6">Transfer Completed</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <List>
                  <ListItem>
                    <ListItemText
                      primary={"Flows"}
                      primaryTypographyProps={{ variant: "h6" }}
                    />
                    <ListItemSecondaryAction>
                      <span
                        style={{
                          padding: "8px 15px",
                          borderRadius: 40,
                          backgroundColor: isCredit ? "green" : "#e65001",
                          color: "white",
                        }}
                      >
                        {transaction_type}
                      </span>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {[
                    { title: "Type", value: `${mode} Transfer` },

                    {
                      title: "Amount",
                      value: <CurrencyFormat amount={amount} />,
                    },
                    {
                      title: "Reference ID",
                      value: uid,
                    },

                    { title: "Date", value: date },
                  ].map((det, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        primary={det.title}
                        primaryTypographyProps={{ variant: "h6" }}
                      />
                      <ListItemSecondaryAction>
                        <Box
                          sx={{
                            width: 160,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            textAlign: "right",
                            textTransform: "capitalize",
                          }}
                        >
                          {det.value}
                        </Box>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    
  );
};
